import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show popup after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={`cookie-consent ${isVisible ? 'visible' : ''}`}>
      <div className="cookie-consent-content">
        <div className="cookie-consent-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="8" cy="9" r="1.5" fill="currentColor"/>
            <circle cx="15" cy="8" r="1" fill="currentColor"/>
            <circle cx="10" cy="14" r="1" fill="currentColor"/>
            <circle cx="16" cy="13" r="1.5" fill="currentColor"/>
            <circle cx="13" cy="17" r="1" fill="currentColor"/>
          </svg>
        </div>
        <div className="cookie-consent-text">
          <h4>We use cookies</h4>
          <p>
            We use cookies to enhance your browsing experience and analyze our traffic. 
            By clicking "Accept All", you consent to our use of cookies. 
            <Link to="/cookie">Learn more</Link>
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button className="cookie-btn decline" onClick={declineCookies}>
            Decline
          </button>
          <button className="cookie-btn accept" onClick={acceptCookies}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
